<template>
    <div v-if="rotate" class="desc desc-down">下降</div>
    <div v-else class="desc desc-up">上升</div>
    <div ref="container" class="container"></div>
</template>

<script setup>
import {computed, onMounted, ref, watch, watchEffect} from 'vue';
import * as echarts from "echarts";
import {ymRate} from "@/tool/number";

const props = defineProps({
  rotate: Boolean | null,
  data: Array,
  city: Array
});
const container = ref();
function calcData(rotate, data){
  if(!rotate){
    return data.reduce((c, n) => {
      c.push(-n);
      return c;
    }, []);
  }
  return data;
}

function init(){
  const c1 = echarts.init(container.value);
  const position = props.rotate ? 'left' : 'right';
  const data = calcData(props.rotate, props.data);
  data.push(0);
  const left = props.rotate ? '10%' : '10%';
  const o1 = {
    grid: [
      {left: left, top: 0}, // 左上角位置
      {right: 0, bottom: 0} // 右下角位置
    ],
    xAxis: {
      max: 'dataMax',
      show: false,
      axisLabel: {
        interval: 0,
      }
    },
    yAxis: {
      type: 'category',
      data: props.city,
      position,
      inverse: true,
      axisLine: {
        show: false
      },
      axisLabel: {
        formatter: function (value) {
          if(value.length <= 4){
            return value;
          }else{
            return value.substr(0, 4);
          }
        }
      },
      axisTick: {
        show: false
      }
    },
    series: [
      {
        data,
        type: 'bar',
        label: {
          formatter: ({data}) => {
            return ymRate(Math.abs(data));
          },
          show: true,
          color: '#333',
          position: props.rotate ? 'right' : 'left'
        },
        barWidth: 20,
        itemStyle:{
          borderRadius: 10,
          color: props.rotate ? '#44cc97' : '#ff8a00'
        }
      }
    ]
  };

  o1 && c1.setOption(o1);
}

watch(props, () => {
  init();
})
onMounted(() => init())
</script>

<style scoped>
.container{
  height: 500px;
}

.desc{
  text-align: center;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
}

.desc-up{
  color: #ff8a00;
}

.desc-down{
  color: #44cc97;
}
</style>